module.exports = __webpack_public_path__ + "img/yioks_yiyi1.6b7685c0.png";